import React,{useState} from 'react';
import {Form,Col,Container,Table,Button,Modal,Tab,Tabs,Row} from 'react-bootstrap';
import Title from '../../../../utilities/other/title';
import {Checkbox,MultiCheckbox} from './formParts';
import new_msa_data from "./new_msa_1.json";
import new_msa_data2 from "./new_msa_2.json";
import './umsars_new.css'
class Umsars_new extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            "part_1":new_msa_data,
            "part_2":new_msa_data2,
            disabled:true

        };
        this.handleChange = this.handleChange.bind(this)
    }
    async handleChange(event){
        

        const {name,checked} = event.target
        var value;
        if (checked){
            value = 1
        }
        else{
            value = 0
        }
        if (name =='table1_essential_features'){
           
           await this.setState((prevState)=>({
                ...prevState,
                disabled:!checked,
                data:{
                    ...prevState.data,
                    [name]:value
                }
            }))
        }
        else{
           await this.setState((prevState)=>({
                ...prevState,
                data:{
                    ...prevState.data,
                    [name]:value
                }
            }))
        }
        this.props.handler("umsars_new",this.state.data)
    }
    componentDidUpdate(prevProps,prevState){
        // if(prevState!=this.state && prevState.disabled == this.state.disabled){
        //     this.props.handler("umsars_new",this.state.data)
        // }
        if(prevProps.disabled!=this.props.disabled){
            this.setState((prevState)=>({
                ...prevState,
                disabled:this.props.disabled
            }))
        }
    }
    componentDidMount(){
       if (this.props.data!=null){
           this.setState((prevState)=>({
               ...prevState,
               data:this.props.data
           }))
       }
      
    }
    
    render(){
        return(

            <Container>
                <Title>MSA criteria - New Guidelines</Title>
                <Tabs defaultActiveKey={'table1'}>
                    <Tab title={"Table 1"} eventKey={'table1'}>
                        <Row>
                            <Col classname='collumn' xl={4}>
                                <p className='title-side'>Essential features:</p>
                            </Col>
                            <Col>
                                <Form>
                                    <Form.Group controlId="formBasicCheckbox">
                                        <Form.Check type="checkbox" label="A sporadic, progressive adult (>30 years) onset disease " name={'table1_essential_features'}
                                            onChange={this.handleChange}
                                            disabled={this.props.data!=null?this.props.disabled:null}
                                            checked={this.props.data!=null?this.props.data['table1_essential_features']:null}
                                        />

                                    </Form.Group>
                                </Form>
                            </Col>
                        </Row> <br/>
                        <Row>
                            <Col xl={4}>
                                <p className='title-side'>Core clinical features</p>
                            </Col>
                            <Col>
                                <Row>
                                    <p style={{'fontWeight':'bold'}} >Clinically established MSA</p>
                                </Row>
                                <MultiCheckbox  title={'1. Autonomic dysfunction defined as (at least one is required)'}
                                options={this.state.part_1.core_clinical_eMSA_1}  data={this.props.data} globalDisabled={true} disabled={this.props.data!=null?this.props.disabled:this.state.disabled} onChange={this.handleChange}/>
                                <MultiCheckbox  title={'and at least one of: '} 
                                options={this.state.part_1.core_clinical_eMSA_2} data={this.props.data} disabled={this.props.data!=null?this.props.disabled:this.state.disabled} onChange={this.handleChange}/>
                            </Col>
                            <Col>
                                <Row>
                                    <p style={{'fontWeight':'bold'}}>Clinically probable MSA</p>
                                </Row>
                                <MultiCheckbox  title={'1. Autonomic dysfunction defined as (at least one is required)'}  data={this.props.data} options={this.state.part_1.core_clinical_pMSA_1} disabled={this.props.data!=null?this.props.disabled:this.state.disabled} onChange={this.handleChange}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={4}>
                                <p className='title-side'>Supportive clinical (motor or non-motor) features</p>
                            </Col>
                            <Col>
                                <Row>
                                    <Checkbox label={'At least two'} name={'table1_supportive_c_m_n_f_eMSA'}disabled={this.props.data!=null?this.props.disabled:this.state.disabled}   data={this.props.data} onChange={this.handleChange}/>
                                </Row>
                            </Col>
                            <Col>
                                <Row>
                                    <Checkbox label={'At least one'} name={'table1_supportive_c_m_n_f_pMSA'} disabled={this.props.data!=null?this.props.disabled:this.state.disabled} data={this.props.data} onChange={this.handleChange}/>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={4}>
                               <p className='title-side'> MRI Marker  </p>
                            </Col>
                            <Col>
                                <Row>
                                    <Checkbox label={'At least one'} name={"table1_mri_marker_eMSA"}disabled={this.props.data!=null?this.props.disabled:this.state.disabled} data={this.props.data} onChange={this.handleChange}/>
                                </Row>
                            </Col>
                            <Col>
                                <Row>
                                    <Checkbox label={'Not Required'} name={"table1_mri_marker_pMSA"} disabled={true} data={this.props.data} onChange={this.handleChange}/>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <h5>Supportive clinical features</h5>
                        </Row>
                        <Row>
                        
                            {/* <Col >
                                Supportive motor features
                            </Col> */}
                            <Col>
                                <MultiCheckbox title={" Supportive motor features"} options={this.state.part_1.supportive_motor_features}  data={this.props.data}disabled={this.props.data!=null?this.props.disabled:this.state.disabled} onChange={this.handleChange} />
                            </Col>
                            {/* <Col >
                                Supportive non-motor features
                            </Col> */}
                            <Col >
                                <MultiCheckbox title={"Supportive non-motor features"} options={this.state.part_1.supportive_non_motor_features}  data={this.props.data} disabled={this.props.data!=null?this.props.disabled:this.state.disabled} onChange={this.handleChange}/>
                            </Col>
                        </Row>
                        <Row>
                            <h5>MRI markers of clinically established MSA</h5>
                        </Row>
                        <Row>
                            <Col>
                                <Row>For MSA-P</Row>
                                <MultiCheckbox title={"Atrophy of: "} 
                                options={this.state.part_1.mri_markers_of_clinically_established_MSA_P} disabled={this.props.data!=null?this.props.disabled:this.state.disabled} data={this.props.data} onChange={this.handleChange}/>
                                <Row>
                                    <Checkbox label={'Hot Cross bun sign'} name={"table1_mri_clinically_eMSA_hcb_sign"} data={this.props.data} disabled={this.props.data!=null?this.props.disabled:this.state.disabled} onChange={this.handleChange}/>
                                </Row>
                            </Col>
                            <Col>
                                <Row> For MSA-C</Row>
                                <MultiCheckbox title={"Atrophy of: "} options={this.state.part_1.mri_markers_of_clinically_established_MSA_C}  data={this.props.data}disabled={this.props.data!=null?this.props.disabled:this.state.disabled} onChange={this.handleChange}/>
                            </Col>
                        </Row>
                        <Row>
                            <h5>Exclusion Criteria</h5>
                            <MultiCheckbox title={""} options={this.state.part_1.exclusion_criteria} disabled={this.props.data!=null?this.props.disabled:this.state.disabled} data={this.props.data} onChange={this.handleChange}/>
                        </Row>
                    </Tab>
                    <Tab eventKey={'table_2'} title={'Table 2'}  >
                        <h5  style={{'textAlign':'center'}}>Research criteria for possible prodromal multiple system atrophy</h5>
                        <br/>
                        <Row>
                            <Col>
                            <p className='title-side'>Clinical non-motor features (entry criteria)</p>
                            </Col>
                            <Col>
                                <MultiCheckbox title={"At least one of the following: "}  disabled={this.props.data!=null?this.props.disabled:this.state.disabled} options={this.state.part_2.clinical_non_motor_features_entry}   data={this.props.data}onChange={this.handleChange}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                            <p className='title-side'>Clinical motor features </p>
                            </Col>
                            <Col>
                                <MultiCheckbox title={"At least one of the following: "}  disabled={this.props.data!=null?this.props.disabled:this.state.disabled}options={this.state.part_2.clinical_motor_features} data={this.props.data} onChange={this.handleChange}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                            <p className='title-side'> Exclusion Criteria</p>
                            </Col>
                            <Col>
                                <MultiCheckbox title={"At least one of the following: "} disabled={this.props.data!=null?this.props.disabled:this.state.disabled} options={this.state.part_2.exclusion_criteria} data={this.props.data}  onChange={this.handleChange}/>
                            </Col>
                        </Row>
                    </Tab>
                </Tabs>
            </Container>
        )
    }

}
Umsars_new.defaultProps ={
    data:null
}

export default Umsars_new;